export const SUCCESS_MAX_RETAIL = "success@maxretail.com";
export const PRODUCT_UPLOAD_MAX_RETAIL = "support@maxretail.com";